document.addEventListener( 'fv_player_loaded', function() {
    console.log('player loaded');
    const api = flowplayer(0);
    api.bind('ready', function() {
        console.log('player ready');
        document.querySelectorAll( '.ld-video[data-video-progression="true"][data-video-provider="' + window.learndash_video_data.videos_found_provider + '"] iframe, .ld-video[data-video-progression="true"][data-video-provider="' + window.learndash_video_data.videos_found_provider + '"] video' ).forEach( function( element, index ) {
            var element_key = 'ld-video-player-' + index;
            var element_id = element.getAttribute( 'id' );
            if ( ( typeof element_id === 'undefined' ) || ( element_id == '' ) ) {
                element_id = element_key;
                element.setAttribute( 'id', element_id );
            }

            // We set our own attribute.
            element.setAttribute( 'data-learndash-video', element_key );

            window.ld_video_players[element_key] = {};
            window.ld_video_players[element_key].player_key = element_key;
            window.ld_video_players[element_key].player_type = window.learndash_video_data.videos_found_provider;
            window.ld_video_players[element_key].player_id = element_id;
            window.ld_video_players[element_key].player_wrapper = element.closest( '.ld-video' );
            if ( typeof window.ld_video_players[element_key].player_wrapper !== 'undefined' ) {
                window.ld_video_players[element_key].player_cookie_key = window.ld_video_players[element_key].player_wrapper.getAttribute( 'data-video-cookie-key' );
            } else {
                window.ld_video_players[element_key].player_cookie_key = '';
            }
            window.ld_video_players[element_key].player_cookie_values = window.LearnDash_Video_Progress_initSettings( window.ld_video_players[element_key] );
            window.ld_video_players[element_key].player = element;
        } );
    });
})